import { SetStateAction, useCallback } from 'react';
import useNotification from '../useNotification';
import useTranslations from '../useTranslations';
import unCompanyFavouriteCarpiProductConfiguration from '@/actions/productWorkflow/carpi/productConfiguration/uncompanyFavouriteCarpiProductConfiguration';
import useAuth from '@/lib/firebase/auth/store';

interface props {
  existingCarpiProductConfigurationId: string;
  setIsCompanyFavourited: (value: SetStateAction<boolean>) => void;
}

export default function useCompanyUnfavourite({
  existingCarpiProductConfigurationId,
  setIsCompanyFavourited,
}: props) {
  const notifications = useNotification();
  const { t, locale } = useTranslations();
  const { userData } = useAuth();
  const companyId = userData.company.id;

  const handleCompanyUnfavouriting = useCallback(async () => {
    const result = await unCompanyFavouriteCarpiProductConfiguration(
      existingCarpiProductConfigurationId,
      locale,
      companyId,
    );
    if (result) {
      setIsCompanyFavourited(false);
      notifications.success(t('product.workflow.companyUnfavourite.success'));
    } else {
      notifications.error(t('product.workflow.companyUnfavourite.error'));
    }
  }, [
    existingCarpiProductConfigurationId,
    locale,
    companyId,
    setIsCompanyFavourited,
    notifications,
    t,
  ]);

  return { handleCompanyUnfavouriting };
}
